// Module
var code = "<div class=\"widget-content\"> <wt-loading-panel is-loading=\"vm.isLoading\" message=\"vm.loadingMessage\"> </wt-loading-panel> <wt-categorical-chart id=\"container{{vm.item.guid}}\" data=\"vm.data\" options=\"vm.options\" ratio=\"vm.ratio\" series=\"vm.series\"> </wt-categorical-chart> </div>";
// Exports
module.exports = code;